import serverCall from "../serverCall";

const getPitchName = async (search) => {
  try {
    const response = await serverCall.get(`/pitch/admin/getall?search=${search ?? ''}`);
    return response;
  } catch (error) {
    console.log("getPitchName error", error);
  }
};

const CreatePitchName = async (name) => {
  console.log("create city data", name);
  try {
    const response = await serverCall.post(`${process.env.REACT_APP_BASE_API_URL}/pitch/admin/create`, { name });
    return response;
  } catch (error) {
    console.log("getCreateCityDataApi error", error);
  }
};

const GetPitchNameSingleId = async (id) => {
  try {
    const response = await serverCall.get(`/pitch/admin/get/${id}`);
    return response;
  } catch (error) {
    console.log("PitchNameSingleId Api error", error);
  }
};

const DeletePitchNameRequest = async (id) => {
  try {
    const response = await serverCall.delete(`/pitch/admin/delete/${id}`);
    return response;
  } catch (error) {
    console.log("DeletePitchType Api error", error);
  }
};

const UpdatePitchNameRequest = async (id, name) => {
  try {
    const response = await serverCall.put(`/pitch/admin/update/${id}`, {
      name,
    });
    return response;
  } catch (error) {
    console.log("UpdateCityData Api error", error);
  }
};

const PitchNameService = {
  getPitchName,
  CreatePitchName,
  GetPitchNameSingleId,
  DeletePitchNameRequest,
  UpdatePitchNameRequest,
};

export default PitchNameService;
